import React, { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import img1 from '../../Image/AdminPro.svg';
import logout from '../../Image/logout.svg';
import notificationOff from '../../Image/notificationsoff.svg';
import notificationOn from '../../Image/notificationson.svg';
import img2 from '../../Image/logo.svg';
import Calling from '../../api/Calling';
import LoadChecker from '../LoadChecker';
import UniversalSearchBar from '../UniversalSearchBar';

const Navbar2 = () => {
    const [controller, setController] = useState(false);
    const [profile, setProfile] = useState(false);
    const [notification, setNotification] = useState(false);
    const [maintenance, setMaintenance] = useState(false);
    const [isMobile, setIsMobile] = useState(false);
    const [cornerMenuOpen, setCornerMenuOpen] = useState(false);
    const cornerMenuRef = useRef(null);

    const navigate = useNavigate();
    const location = useLocation();

    // Detect mobile screens
    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
        };

        handleResize(); // Check on initial load
        window.addEventListener('resize', handleResize);

        return () => window.removeEventListener('resize', handleResize);
    }, []);

    // Close corner menu when clicking outside
    useEffect(() => {
        function handleClickOutside(event) {
            if (cornerMenuRef.current && !cornerMenuRef.current.contains(event.target)) {
                setCornerMenuOpen(false);
            }
        }

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [cornerMenuRef]);

    // Set active states based on current route
    useEffect(() => {
        const C_State = location.pathname.replaceAll('/', '');
        setController(C_State === 'controller');
        setProfile(C_State === 'profile');
        setNotification(C_State === 'notification');
    }, [location.pathname]);

    useEffect(() => {
        fetchData();
    }, []);

    // Handle navigation and close menus
    const handleNavigation = (path) => {
        navigate(path);
        setCornerMenuOpen(false);
    };

    const fetchData = async () => {
        try {
            const resp = await Calling?.getMaintenance();
            if (resp?.status) {
                setMaintenance(resp?.data?.exclusive_module);
            } else {
                console.log(resp?.message);
            }
        } catch (error) {
            console.log("app maintenance :" + error);
        }
    };

    return (
        <nav className="fixed top-0 w-full bg-main-white text-main-font shadow-sm z-30">
            <div className="flex flex-wrap items-center justify-between px-4 py-3 md:px-6 lg:px-8">
                {/* Logo Section */}
                <div className="flex items-center">
                    <img
                        src={img2}
                        alt="App Logo"
                        className="hidden lg:block w-[40px] lg:w-[120px] cursor-pointer transition-transform duration-300 hover:scale-110"
                        onClick={() => navigate('/')}
                    />
                </div>

                {/* Mobile Corner Button */}
                {isMobile && (
                    <div className="md:hidden relative" ref={cornerMenuRef}>
                        <button
                            className="flex items-center justify-center w-10 h-10 rounded-full bg-main-blue text-white shadow-lg 
                                       transition-all duration-300 active:scale-95 hover:bg-blue-600"
                            onClick={() => setCornerMenuOpen(!cornerMenuOpen)}
                            aria-label="Menu"
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                className={`h-6 w-6 transform transition-transform duration-300 ${cornerMenuOpen ? 'rotate-90' : ''}`}
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="M4 6h16M4 12h16M4 18h16"
                                />
                            </svg>
                        </button>

                        {/* Corner dropdown menu */}
                        {cornerMenuOpen && (
                            <div className="absolute right-0 mt-2 w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 z-50
                                            animate-slide-down">
                                <div className="py-1 divide-y divide-gray-100">
                                    <CornerMenuItem
                                        icon={
                                            controller ? (
                                                <svg width="20" height="10" viewBox="0 0 28 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M7.75 13.875C5.84021 13.875 4.21698 13.2069 2.88031 11.8706C1.54344 10.5344 0.875 8.91177 0.875 7.00281C0.875 5.09385 1.54344 3.47031 2.88031 2.13219C4.21698 0.794062 5.84021 0.125 7.75 0.125H20.25C22.1598 0.125 23.783 0.793125 25.1197 2.12938C26.4566 3.46563 27.125 5.08823 27.125 6.99719C27.125 8.90615 26.4566 10.5297 25.1197 11.8678C23.783 13.2059 22.1598 13.875 20.25 13.875H7.75ZM20.2484 10.4375C21.203 10.4375 22.0148 10.1034 22.6838 9.43531C23.3529 8.76719 23.6875 7.95594 23.6875 7.00156C23.6875 6.04698 23.3534 5.23521 22.6853 4.56625C22.0172 3.89708 21.2059 3.5625 20.2516 3.5625C19.297 3.5625 18.4852 3.89656 17.8162 4.56469C17.1471 5.23281 16.8125 6.04406 16.8125 6.99844C16.8125 7.95302 17.1466 8.76479 17.8147 9.43375C18.4828 10.1029 19.2941 10.4375 20.2484 10.4375Z" fill="white" />
                                                </svg>
                                            ) : (
                                                <svg width="20" height="10" viewBox="0 0 28 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M7.75 13.875C5.84021 13.875 4.21698 13.2069 2.88031 11.8706C1.54344 10.5344 0.875 8.91177 0.875 7.00281C0.875 5.09385 1.54344 3.47031 2.88031 2.13219C4.21698 0.794062 5.84021 0.125 7.75 0.125H20.25C22.1598 0.125 23.783 0.793125 25.1197 2.12938C26.4566 3.46563 27.125 5.08823 27.125 6.99719C27.125 8.90615 26.4566 10.5297 25.1197 11.8678C23.783 13.2059 22.1598 13.875 20.25 13.875H7.75ZM7.75 12H20.25C21.625 12 22.8021 11.5104 23.7812 10.5312C24.7604 9.55208 25.25 8.375 25.25 7C25.25 5.625 24.7604 4.44792 23.7812 3.46875C22.8021 2.48958 21.625 2 20.25 2H7.75C6.375 2 5.19792 2.48958 4.21875 3.46875C3.23958 4.44792 2.75 5.625 2.75 7C2.75 8.375 3.23958 9.55208 4.21875 10.5312C5.19792 11.5104 6.375 12 7.75 12ZM7.74844 10.4375C8.70302 10.4375 9.51479 10.1034 10.1838 9.43531C10.8529 8.76719 11.1875 7.95594 11.1875 7.00156C11.1875 6.04698 10.8534 5.23521 10.1853 4.56625C9.51719 3.89708 8.70594 3.5625 7.75156 3.5625C6.79698 3.5625 5.98521 3.89656 5.31625 4.56469C4.64708 5.23281 4.3125 6.04406 4.3125 6.99844C4.3125 7.95302 4.64656 8.76479 5.31469 9.43375C5.98281 10.1029 6.79406 10.4375 7.74844 10.4375Z" fill="#6849FF" />
                                                </svg>
                                            )
                                        }
                                        text="Controller"
                                        isActive={controller}
                                        onClick={() => handleNavigation('/controller')}
                                    />

                                    <CornerMenuItem
                                        icon={<img src={img1} className="w-5 h-5" alt="profile" />}
                                        text="Profile"
                                        isActive={profile}
                                        onClick={() => handleNavigation('/profile')}
                                    />
                                    <CornerMenuItem
                                        icon={<img src={notificationOff} className="w-5 h-5" alt="notification" />}
                                        text="Notification"
                                        isActive={notification}
                                        onClick={() => handleNavigation('/notification')}
                                    />

                                    <CornerMenuItem
                                        icon={<img src={logout} className="w-5 h-5" alt="logout" />}
                                        text="Logout"
                                        onClick={() => handleNavigation('/Logout')}
                                    />
                                    <div className="px-3 py-2">
                                        <div className="text-xs font-medium text-gray-500 mb-2">Server Status</div>
                                        <LoadChecker isMobile={true} isCompact={true} />
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                )}

                {/* Desktop Controls */}
                <div className="hidden md:flex md:items-center md:justify-between md:flex-grow md:ml-6">
                    <ControllerButton
                        controller={controller}
                        navigate={navigate}
                        maintenance={maintenance}
                    />
                    <div className="flex justify-end">
                        <LoadChecker />
                    </div>
                    <UniversalSearchBar />
                </div>

                {/* Desktop User Controls */}
                <div className="hidden md:flex md:items-center md:space-x-4 lg:space-x-6">
                    <button
                        className={`hover:text-secondary-teal ${notification ? "border-b-2 border-main-blue" : ''} 
                                    flex justify-center p-1 transition-all duration-300 
                                    hover:scale-110 active:scale-95`}
                        onClick={() => navigate('/notification')}
                        aria-label="Notification"
                    >
                        <img src={notification ? notificationOn : notificationOff} className="w-7 sm:w-8" alt="notification" />
                    </button>
                    <button
                        className={`hover:text-secondary-teal ${profile ? "border-b-2 border-main-blue" : ''} 
                                    flex justify-center p-1 transition-all duration-300 
                                    hover:scale-110 active:scale-95`}
                        onClick={() => navigate('/profile')}
                        aria-label="Profile"
                    >
                        <img src={img1} className="w-7 sm:w-8" alt="profile" />
                    </button>
                    <button
                        className="hover:text-secondary-teal p-1 
                                   transition-all duration-300 
                                   hover:scale-110 active:scale-95"
                        onClick={() => navigate('/Logout')}
                        aria-label="Logout"
                    >
                        <img src={logout} className="w-6 sm:w-7" alt="logout" />
                    </button>
                </div>
            </div>
        </nav>
    );
};

export default Navbar2;

// Separate CornerMenuItem Component
const CornerMenuItem = ({ icon, text, isActive = false, onClick }) => {
    return (
        <div className="px-3 py-2">
            <div
                className={`cursor-pointer rounded-md px-3 py-2 transition-all duration-300
                           ${isActive
                        ? 'bg-main-blue text-white'
                        : 'hover:bg-gray-100 hover:scale-105 active:scale-95'}`}
                onClick={onClick}
            >
                <div className="flex items-center">
                    {icon}
                    <span className="ml-2">{text}</span>
                </div>
            </div>
        </div>
    );
};

// Separate ControllerButton Component
const ControllerButton = ({ controller, navigate }) => {
    const handleClick = () => {
        navigate('/controller');
    };

    return (
        <div
            className={`w-auto ${controller ? "border-b-2 border-main-blue" : ''} pt-1 pb-1`}
            onClick={handleClick}
        >
            <div className={`
                flex items-center border border-main-border rounded-lg justify-center 
                px-2 py-1 
                shadow-sm ${controller ? 'bg-main-blue' : ''} 
                transition-all duration-300 hover:scale-105 
                active:scale-95 cursor-pointer
            `}>
                <label className="flex cursor-pointer items-center space-x-2">
                    {controller ? (
                        <svg width="28" height="14" viewBox="0 0 28 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M7.75 13.875C5.84021 13.875 4.21698 13.2069 2.88031 11.8706C1.54344 10.5344 0.875 8.91177 0.875 7.00281C0.875 5.09385 1.54344 3.47031 2.88031 2.13219C4.21698 0.794062 5.84021 0.125 7.75 0.125H20.25C22.1598 0.125 23.783 0.793125 25.1197 2.12938C26.4566 3.46563 27.125 5.08823 27.125 6.99719C27.125 8.90615 26.4566 10.5297 25.1197 11.8678C23.783 13.2059 22.1598 13.875 20.25 13.875H7.75ZM20.2484 10.4375C21.203 10.4375 22.0148 10.1034 22.6838 9.43531C23.3529 8.76719 23.6875 7.95594 23.6875 7.00156C23.6875 6.04698 23.3534 5.23521 22.6853 4.56625C22.0172 3.89708 21.2059 3.5625 20.2516 3.5625C19.297 3.5625 18.4852 3.89656 17.8162 4.56469C17.1471 5.23281 16.81256.04406 16.8125 6.99844C16.8125 7.95302 17.1466 8.76479 17.8147 9.43375C18.4828 10.1029 19.2941 10.4375 20.2484 10.4375Z" fill="white" />
                        </svg>
                    ) : (
                        <svg width="28" height="14" viewBox="0 0 28 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M7.75 13.875C5.84021 13.875 4.21698 13.2069 2.88031 11.8706C1.54344 10.5344 0.875 8.91177 0.875 7.00281C0.875 5.09385 1.54344 3.47031 2.88031 2.13219C4.21698 0.794062 5.84021 0.125 7.75 0.125H20.25C22.1598 0.125 23.783 0.793125 25.1197 2.12938C26.4566 3.46563 27.125 5.08823 27.125 6.99719C27.125 8.90615 26.4566 10.5297 25.1197 11.8678C23.783 13.2059 22.1598 13.875 20.25 13.875H7.75ZM7.75 12H20.25C21.625 12 22.8021 11.5104 23.7812 10.5312C24.7604 9.55208 25.25 8.375 25.25 7C25.25 5.625 24.7604 4.44792 23.7812 3.46875C22.8021 2.48958 21.625 2 20.25 2H7.75C6.375 2 5.19792 2.48958 4.21875 3.46875C3.23958 4.44792 2.75 5.625 2.75 7C2.75 8.375 3.23958 9.55208 4.21875 10.5312C5.19792 11.5104 6.375 12 7.75 12ZM7.74844 10.4375C8.70302 10.4375 9.51479 10.1034 10.1838 9.43531C10.8529 8.76719 11.1875 7.95594 11.1875 7.00156C11.1875 6.04698 10.8534 5.23521 10.1853 4.56625C9.51719 3.89708 8.70594 3.5625 7.75156 3.5625C6.79698 3.5625 5.98521 3.89656 5.31625 4.56469C4.64708 5.23281 4.3125 6.04406 4.3125 6.99844C4.3125 7.95302 4.64656 8.76479 5.31469 9.43375C5.98281 10.1029 6.79406 10.4375 7.74844 10.4375Z" fill="#6849FF" />
                        </svg>
                    )}
                    <span className={`${controller ? 'text-main-white' : 'text-main-font'} text-sm lg:text-base`}>
                        Controller
                    </span>
                </label>
            </div>
        </div>
    );
};

